const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.MATERIALS)

export const apiMaterials = {
	fetchMaterials: async (
		filters?: {
			tags?: string[] | undefined
			diets?: string[] | undefined
			search?: string | undefined
			ids?: number[]
		},
		pagination: IApiPagination = { page: 1, perPage: 25 },
		only?: {
			alternatives?: boolean | undefined
			used_as_alternative_in?: boolean | undefined
		},
	): Promise<IApiResponseModel<IDietaryMaterialListModel[]>> => {
		const onlyAsString = getStringFromObject(only)

		const { data, meta } = await apiCommon<IDietaryMaterialList[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(
				pagination,
				{
					id: filters?.ids,
					tags: filters?.tags,
					diets: filters?.diets,
					internal_name: filters?.search,
				},
				undefined,
				{ only: onlyAsString },
			),
		})
		return { data: data.map(DietaryMaterialList), meta }
	},
	fetchMaterialsRelated: async (materialId: number): Promise<IApiResponseModel<IDietaryRawMaterialRelatedModel>> => {
		const { data } = await apiCommon<IDietaryRawMaterialRelated>(`${groupPrefix}/${materialId}/related`, {
			method: 'GET',
		})

		return { data: DietaryRawMaterialRelated(data), meta: undefined }
	},
	fetchMaterialById: async (id: string | number): Promise<IDietMaterialModel> => {
		const { data } = await apiCommon<IDietaryMaterial>(`${groupPrefix}/${id}`, { method: 'GET' })

		return DietaryMaterial(data)
	},
	createDietMaterial: async (payload: IDietMaterialCreatePayload): Promise<IDietMaterialModel> => {
		const { data } = await apiCommon<IDietaryMaterial>(`${groupPrefix}`, { method: 'POST', body: payload })

		return DietaryMaterial(data)
	},
	updateDietMaterial: async (payload: IDietMaterialUpdatePayload): Promise<IDietMaterialModel> => {
		const { data } = await apiCommon<IDietaryMaterial>(`${groupPrefix}/${payload.id}`, {
			method: 'PUT',
			body: payload,
		})

		return DietaryMaterial(data)
	},
	duplicateDietMaterial: async (id: number): Promise<IDietMaterialModel> => {
		const { data } = await apiCommon<IDietaryMaterial>(`${groupPrefix}/${id}/duplicate`, { method: 'POST' })

		return DietaryMaterial(data)
	},
	deleteDietMaterial: async (id: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/${id}`, { method: 'DELETE' })
	},
	fetchDietMaterialEditHistory: async (
		id: number,
		search: IApiSearch,
		{ page, perPage = 25 }: IApiPagination,
		filters?: IApiFilters,
	): Promise<IApiResponseModel<IDietaryActivityBusinessEventModel[]>> => {
		const searchFilter = createSearchQuery(search.query, search.type)
		const { data, meta } = await apiCommon<IDietaryActivityBusinessEvent[]>(`${groupPrefix}/${id}/logs`, {
			method: 'GET',
			...createQuery({ page, perPage }, { ...searchFilter, ...filters }),
		})

		return { data: data.map(DietaryActivityBusinessEvent), meta }
	},
	exportRawMaterialsMenuRaport: async (dateFrom: Date, dateTo: Date) => {
		const dateFromFormatted = dateToFilterFormat(dateFrom)
		const dateToFormatted = dateToFilterFormat(dateTo)

		const response = await apiCommonRaw<BlobPart>(
			`${groupPrefix}/export/menu/download?date_from=${dateFromFormatted}&date_to=${dateToFormatted}`,
			{
				method: 'GET',
				responseType: 'blob',
			},
		)

		downloadFileFromResponse(response, `${dateFromFormatted}-${dateToFormatted}-raw-materials-export.xlsx`)
	},
}
